import { createAction } from 'redux-act';

export const RSSDATA_SET_DATA = createAction('RSSDATA_SET_DATA');

export const setRSSData = (id, lastUpdate, data) => dispatch => {
  return dispatch(RSSDATA_SET_DATA({ id, lastUpdate, data }));
};